import Picker, { type DatePickerProps } from "react-datepicker";
import { useId, type ReactNode } from "react";
import { css, cx } from "../../../../styled-system/css";
import { inputClassNames } from "../styles/styles";
import { Label } from "react-aria-components";
import moment from "moment";

type Props = Omit<
  DatePickerProps,
  "selected" | "onChange" | "selectsRange" | "selectsMultiple" | "excludeScrollbar" | "onSelect"
> & {
  label?: ReactNode;
  labelTooltip?: string;
  value?: string | null;
  /**
   * @param date ISO 8601 date string
   */
  onChange?: (date: string | null) => void;
  className?: string;
  inputClassName?: string;
  selectsMultiple?: never;
  selectsRange?: never;
  ignoreUtc?: boolean;
};

export function Datepicker({ label, value, onChange, className, inputClassName, ignoreUtc = false, ...rest }: Props) {
  const inputId = useId();
  const selected =
    value ?
      ignoreUtc ? moment(value, "YYYY-MM-DD").toDate()
      : new Date(Date.parse(value))
    : null;
  const classes = inputClassNames();

  return (
    <div className={cx(classes.fieldWrapper, className)}>
      <Label htmlFor={inputId} className={classes.label}>
        {label}
      </Label>

      <Picker
        {...rest}
        showMonthYearDropdown={undefined} // This bypasses some weird type issue, see https://github.com/Hacker0x01/react-datepicker/issues/5198
        className={cx(
          css({
            _disabled: { cursor: "not-allowed", backgroundColor: "lightgrey" },
          }),
          inputClassName,
        )}
        selected={selected}
        onChange={(date) =>
          onChange?.(
            date ?
              ignoreUtc ? moment(date).format("YYYY-MM-DD")
              : date.toISOString()
            : null,
          )
        }
      />
    </div>
  );
}
